import { IDeviceIdentificationObject } from './device-identification-object.interface';

export interface ICreateDeviceDto {
    externalId: string;
    externalIdSource: string;
    organizationId: string;
    platformId: number;
    name: string;
    code: string;
    identification: IDeviceIdentificationObject;
}
